import PropTypes from 'prop-types';

import NavigationDefault from './NavigationDefault';
import NavigationSticky from './NavigationSticky';

import { CtfNavigationStyle } from '@/utils/constants';
import NavigationWestholme from './NavigationWestholme';
import { isDDEnv } from '@/utils/helper';

function Navigation({
  fields,
  entries = [],
  assets = [],
  hasBackground,
  hideLogo,
  isBlock,
  slug,
  tags,
  navigationColor
}) {
  const style = fields?.navigationStyle || CtfNavigationStyle.DEFAULT;
  // let colorNav
  const isDD = isDDEnv();

  if (style === CtfNavigationStyle.STICKY) {
    return (
      <NavigationSticky
        fields={fields}
        assets={assets}
        entries={entries}
        slug={slug}
        tags={tags}
        hideLogo={hideLogo}
      />
    );
  }

  if(isDD) {
    return (
      <NavigationDefault
        fields={fields}
        assets={assets}
        entries={entries}
        hasBackground={hasBackground}
        isBlock={isBlock}
        slug={slug}
        tags={tags}
        hideLogo={hideLogo}
      />
    );
  }

  return (
    <NavigationWestholme
      fields={fields}
      entries={entries}
      hasBackground={hasBackground}
      hideLogo={hideLogo}
      navigationColor={navigationColor}
    />
  );
}

// @TODO: define real props for the Navigation based on it requirements
Navigation.propTypes = {
  entries: PropTypes.array,
  fields: PropTypes.object,
  hasBackground: PropTypes.bool,
  tagGroupsWithTags: PropTypes.array,
  slug: PropTypes.string,
  navigationColor: PropTypes.string,
};

Navigation.defaultProps = {
  hasBackground: false,
};

export default Navigation;
